module.exports = "<div class=\"confirm-dialog\">\n  <p>{{data.title}}</p>\n  <div mat-dialog-actions>\n    <button (click)=\"closeDialog(true)\" mat-raised-button>\n      დიახ\n    </button>\n    <button (click)=closeDialog(false) mat-raised-button>\n      არა\n    </button>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/admin/components/shared/petition-details/dialogs/review-results-dialog/dialogs/confirmation-dialog/confirmation-dialog.component.html
// module id = ../../../../../src/app/components/admin/components/shared/petition-details/dialogs/review-results-dialog/dialogs/confirmation-dialog/confirmation-dialog.component.html
// module chunks = main